// controllers/collapse_content_controller.js
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['content', 'icon'];

  connect() {
    this.loaded = false;
    this.updateChevron();
  }

  toggle() {
    this.contentTarget.classList.toggle('hidden');
    const isHidden = this.contentTarget.classList.contains('hidden');
    this.updateChevron();

    if (!this.loaded && !isHidden) {
      this.loadContent();
    }
  }

  updateChevron() {
    const isHidden = this.contentTarget.classList.contains('hidden');
    this.iconTarget.style.transform = isHidden ? 'rotate(0deg)' : 'rotate(180deg)';
    this.iconTarget.title = isHidden ? 'Show section' : 'Hide';
  }

  loadContent() {
    const url = this.contentTarget.dataset.lazyUrl;
    if (!url) return;

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        this.contentTarget.innerHTML = html;
        this.loaded = true;
      })
      .catch((err) => {
        this.contentTarget.innerHTML = "<p class='text-red-600'>Failed to load data.</p>";
        console.error('Error loading content:', err);
      });
  }
}
